import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { launchApp } from '../actions/sessionActions';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

import '../pages/_partials/Layout/style.scss';
import 'typicons.font/src/font/typicons.css';

import Routes from '../configs/routes';
import Login from '../pages/Login';
import Loading from '../pages/Loading';
import moment from "moment";

library.add(fab, fas, far);

moment.updateLocale('en', {
  week: {
    dow: 1,
  },
})

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const { token, status } = useAppSelector(state => state.session);

  useEffect(() => {
    if (token && status === 'idle') {
      dispatch(launchApp());
    }
  }, [token, status, dispatch]);

  if(!token) {
    return <Login />;
  }

  if (status === 'idle' || status === 'loading') {
    return <Loading />;
  }

  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
}

export default App;
